import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { HeaderTools } from '../../../assets/images/imageRepository';
import { ToolsHeroShapes, piper } from '../../../assets/illustrations/illustrationRepository';
import mediaQueries from '../../../utils/mediaQueries';

const Hero = styled.header`
  background-image: url(${HeaderTools.mobile});
  background-size: cover;
  background-repeat: no-repeat;
  height: 487px;
  padding-left: 24px;
  padding-top: 33px;
  position: relative;
  @media ${mediaQueries.mdUp} {
    background-image: url(${HeaderTools.tablet});
    background-position: center;
    height: 376px;
  }
  @media ${mediaQueries.xlPlusUp} {
    padding-top: 75px;
    padding-left: 102px;
  }
  @media (min-width: 1441px) {
    padding-left: 0;
  }
`;
const Container = styled.div`
  @media (min-width: 1441px) {
    max-width: 1424px;
    margin: 0 auto;
    padding-left: 100px
  }
`;
const Title = styled.h1`
  color: ${({ theme }) => theme.colors.black3E};
  font-size: 40px;
  font-weight: bold;
  line-height: 54px;
  ${({ isSpanish }) => isSpanish && `
    background: rgba(255,255,255, 0.5);
    border-radius: 0px 4px 4px 0px;
    max-width: 319px;
  `}
`;
const Description = styled.h2`
  color: ${({ theme }) => theme.colors.black3E};
  font-size: 19px;
  font-weight: 600;
  line-height: 26px;
  margin-top: 12px;
  @media ${mediaQueries.mdUp} {
    br:nth-child(1) {
      display: none;
    }
    br:nth-child(3) {
      display: none;
    }
    br:nth-child(5) {
      display: none;
    }
    br:nth-child(6) {
      display: none;
    }
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 28px;
    line-height: 38px;
    max-width: 528px;
    margin-top: 20px;
    br {
      display: none;
    }
  }
`;
const IllustrationContainer = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  right: -90px;
  @media ${mediaQueries.lgPlusUp} {
    display: block;
  }
`;
const ShapesContainer = styled.div`
  width: 125px;
  @media ${mediaQueries.lgPlusUp} {
    position: relative;
    top: 154px;
    right: 80px;
    width: 302px;
    z-index: 0;
  }
`;
const Shapes = styled.img`
  width: 100%;
`;
const PiperContainer = styled.div`
  display: flex;
  width: 267px;
  @media ${mediaQueries.lgPlusUp} {
    position: relative;
    width: 318px;
    z-index: 1;
  }
`;
const Piper = styled.img`
  width: 100%;
`;
const Header = () => {
  const intl = useIntl();
  return (
    <Hero>
      <Container>
        <Title isSpanish={intl.locale === 'es'}>
          <FormattedMessage
            id="tools.header.title"
            defaultMessage="Tools"
          />
        </Title>
        <Description>
          <FormattedMessage
            id="tools.header.description"
            defaultMessage="User-friendly tools {lineBreak}and tailored tips let {lineBreak}you easily create, {lineBreak}or dramatically {lineBreak}improve, your {lineBreak}social media {lineBreak}presence"
            values={{
              lineBreak: <br />,
            }}
          />
        </Description>
      </Container>
      <IllustrationContainer>
        <ShapesContainer>
          <Shapes src={ToolsHeroShapes} alt="Tools Shapes" />
        </ShapesContainer>
        <PiperContainer>
          <Piper src={piper.PiperTool} alt="Piper Tool" />
        </PiperContainer>
      </IllustrationContainer>
    </Hero>
  );
};

export default Header;
